import { axiosCustom } from 'common/common.function';

export interface SendChatPromptInput {
  prompt: string;
  sessionId?: string;
  file?: File; // Optional file
  allowHighRisk?: boolean; // Optional flag
  userId?: number;
  name?: string;
}

/**
 * @alias 챗봇 메시지 전송
 */
export const sendChatPrompt = async (data: FormData | SendChatPromptInput) => {
  return await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/chat`, data, {
    headers: {
      // Content-Type is optional here as axios/browser sets it for FormData automatically with boundary
      // But explicit typing helps.
    },
  });
};
